// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__Uo6U4","title":"Images45_title__3lMY3","images":"Images45_images__3aF3C"};